import SideBar from "../common/sharedComponents/SideBar";
import AppRouter from "../routes/AppRouter";
import { AppHolder } from "../styles/app.style";
import ChatBort from "../features/chatbort/ChatBort";

function App() {
  return (
    <AppHolder>
      <SideBar />
      <AppRouter />
      <ChatBort />
    </AppHolder>
  );
}

export default App;
